import { type FC } from 'react';
import { ModalContainer, ModalHeader } from '@/utils/modal';
import { SamplePlanTableView } from '@/components/Samples/SamplePlanTableView';

interface SamplePlanTableViewModalProps {
  closeModal: () => void;
}

/**
 * Opens the legacy v1 SamplePlanTableView inside a wide modal.
 * The inner component is self-contained and fetches its own data via useParams.
 */
export const SamplePlanTableViewModal: FC<SamplePlanTableViewModalProps> = ({ closeModal }) => (
  <ModalContainer size="wide">
    <ModalHeader title="Sample Plan" closeModal={closeModal} />
    <SamplePlanTableView />
  </ModalContainer>
);
